<h1 [innerText]="h1Heading" class="sr-only"></h1>

<!-- Static banner option (No carousel) -->
@if (!block.data.isCarousel) {
    <!-- Default full screen width Hero option -->
    @if (!block.data.isNotFullWidth) {
        <ng-container *ngTemplateOutlet="heroContent; context: { item: block }"></ng-container>
    }

    <!-- Non full screen width Hero option. This has a split layout of CTA on left and image on right -->
    @if (block.data.isNotFullWidth) {
        <ng-container *ngTemplateOutlet="heroContentNotFullWidth; context: { item: block }"></ng-container>
    }
}

<!-- Carousel option -->
@if (block.data.isCarousel) {
    <div class="position-relative">
        <swiper #homeBannerSwiper [config]="swiperConfig">
            @for (item of block.content; track trackByFn($index, item)) {
                <div swiperSlide>
                    @if (!block.data.isNotFullWidth) {
                        <ng-container *ngTemplateOutlet="heroContent; context: { item: item }"></ng-container>
                    }
                    @if (block.data.isNotFullWidth) {
                        <ng-container
                            *ngTemplateOutlet="heroContentNotFullWidth; context: { item: item }"></ng-container>
                    }
                </div>
            }
        </swiper>
        <div class="swiper-button-home-prev">
            <div class="swiper-button-home-prev__icon"></div>
        </div>
        <div class="swiper-button-home-next">
            <div class="swiper-button-home-next__icon"></div>
        </div>
        <div class="home-banner__navigation-wrapper">
            <div
                [ngClass]="{ 'navigation-outer--dots-on-left': isCarouselDotsPositionOnLeft }"
                class="container navigation-outer">
                <div class="navigation-inner">
                    <div class="swiper-pagination-home"></div>
                </div>
            </div>
        </div>
    </div>
}

<!-- Default full screen width Hero content -->
<ng-template #heroContent let-item="item">
    <div
        [ngClass]="{
            'home-banner--inverted': block.data.inverted,
            'home-banner--gradient-overlay': block.data.gradientOverlay,
        }"
        [style.background-image]="getBackground(item.data.image)"
        [style.background-position]="item.data.heroImagePosition"
        class="home-banner">
        <div class="home-banner__container container">
            <div class="home-banner__content">
                @if (item.data.heading) {
                    <h2 [innerHTML]="item.data.heading" class="home-banner__heading-primary"></h2>
                }
                @if (item.data.subheading) {
                    <h3 [innerHTML]="item.data.subheading" class="home-banner__heading-secondary"></h3>
                }
                @if (item.data.content) {
                    <div [innerHTML]="item.data.content" class="home-banner__paragraph"></div>
                }
                @if (item.data.link && !item.data.targetAttr) {
                    <a
                        [attr.aria-label]="item.data.linkAriaLabel"
                        [core-analytics]="{ action: block.data.linkText, block }"
                        [innerText]="item.data.linkText ?? 'Learn more'"
                        [routerLink]="item.data.link"
                        [target]="item.data.targetAttr ? '_blank' : '_self'"
                        class="btn btn-primary"></a>
                }

                @if (item.data.link && item.data.targetAttr) {
                    <a
                        [attr.aria-label]="item.data.linkAriaLabel"
                        [core-analytics]="{ action: block.data.linkText, block }"
                        [href]="item.data.link"
                        [innerText]="item.data.linkText ?? 'Learn more'"
                        [target]="item.data.targetAttr ? '_blank' : '_self'"
                        class="btn btn-primary"></a>
                }
            </div>
        </div>
    </div>
</ng-template>

<!-- Non full screen width Hero content. This has a split layout of CTA on left and image on right -->
<ng-template #heroContentNotFullWidth let-item="item">
    <div
        [ngClass]="{
            'home-banner--inverted': block.data.inverted,
            'home-banner--not-full-width': block.data.isNotFullWidth,
        }"
        class="home-banner">
        <div class="home-banner__content">
            <div class="home-banner__content-inner">
                @if (item.data.heading) {
                    <h2 [innerHTML]="item.data.heading" class="home-banner__heading-primary"></h2>
                }
                @if (item.data.subheading) {
                    <h3 [innerHTML]="item.data.subheading" class="home-banner__heading-secondary"></h3>
                }
                @if (item.data.content) {
                    <div [innerHTML]="item.data.content" class="home-banner__paragraph"></div>
                }
                @if (item.data.link && !item.data.targetAttr) {
                    <a
                        [attr.aria-label]="item.data.linkAriaLabel"
                        [core-analytics]="{ action: block.data.linkText, block }"
                        [innerText]="item.data.linkText ?? 'Learn more'"
                        [routerLink]="item.data.link"
                        [target]="item.data.targetAttr ? '_blank' : '_self'"
                        class="btn btn-primary align-self-start"></a>
                }

                @if (item.data.link && item.data.targetAttr) {
                    <a
                        [attr.aria-label]="item.data.linkAriaLabel"
                        [core-analytics]="{ action: block.data.linkText, block }"
                        [href]="item.data.link"
                        [innerText]="item.data.linkText ?? 'Learn more'"
                        [target]="item.data.targetAttr ? '_blank' : '_self'"
                        class="btn btn-primary align-self-start"></a>
                }
            </div>
        </div>
        <div
            class="home-banner__image"
            [style.background-image]="getBackground(item.data.image)"
            [style.background-position]="item.data.heroImagePosition"></div>
    </div>
</ng-template>
